import { Component, Inject, OnInit } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { InstanceTypes } from '../../models/instance-types';
import { Router } from '@angular/router';
import { ExternalRedirectService } from '../../services/external-redirect.service';

@Component({
  selector: 'app-missing-permissions',
  templateUrl: './missing-permissions.component.html',
  styleUrls: ['./missing-permissions.component.css'],
  standalone: false
})
export class MissingPermissionsComponent implements OnInit {
  loaded = false;

  constructor(
    private authService: AuthService,
    @Inject('env') private env: any,
    private externalRedirectService: ExternalRedirectService
  ) {}

  ngOnInit(): void {
    if (this.env.instanceType === InstanceTypes.CsrPortal) {
      if (
        !this.authService.isInAnyRole(['CSR', 'CSR1']) &&
        this.authService.isInAnyRole([
          'Client Portal Admin',
          'Client Portal User',
          'Employee Portal User'
        ])
      ) {
        this.externalRedirectService.redirectTo(this.env.landingPortalUrl);
      } else {
        this.loaded = true;
      }
    } else {
      if (
        this.authService.isInAnyRole(['CSR', 'CSR1']) &&
        !this.authService.isInAnyRole([
          'Client Portal Admin',
          'Client Portal User',
          'Employee Portal User'
        ])
      ) {
        this.externalRedirectService.redirectTo(this.env.opsPortalUrl);
      } else {
        this.loaded = true;
      }
    }
  }

  logOut() {
    this.authService.signOut();
  }
}
